const GoogleMap = {
  rendeder: {
    render: function ({ count, position }, stats) {
      // create svg url with fill color
      const svg = window.btoa(`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108 108">
          <circle cx="54" cy="54" r="54" fill="#e6e6e6" opacity="0.4" />
          <circle cx="54" cy="54" r="48" fill="#e6e6e6" opacity="0.4" />
          <circle cx="54" cy="54" r="40" fill="#04039a" />
        </svg>`);
      // create marker using svg icon
      return new google.maps.Marker({
        position,
        icon: {
          url: `data:image/svg+xml;base64,${svg}`,
          scaledSize: new google.maps.Size(54, 54),
        },
        label: {
          text: String(count),
          color: "rgba(255,255,255,0.9)",
          fontSize: "12px",
        },
        // adjust zIndex to be above other markers
        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
      });
    },
  },
};

export default GoogleMap;
